import React from 'react';
import { ButtonOne } from '../../../components/ButtonOne/ButtonOne.component';
import styles from './ImageLoadErrorPage.module.css';

interface ImageLoadErrorPageProps {
  onRetry: () => void;
  previewCardFullWidth?: boolean;
}

export const ImageLoadErrorPage: React.FC<ImageLoadErrorPageProps> = ({ onRetry, previewCardFullWidth }) => {
  return (
    <div className={previewCardFullWidth ? styles.container : styles.containerNarrow}>
      <h1 className={styles.title}>Nie udało się załadować obrazu pracy</h1>
      <p className={styles.subtitle}>Spróbuj odświeżyć stronę</p>
      <ButtonOne variant="contained" color="primary" onClick={onRetry}>
        ODŚWIEŻ
      </ButtonOne>
    </div>
  );
};
